import React, { useEffect, useState } from 'react'
import { SxProps, Theme } from '@mui/material/styles'
import Box from '@mui/material/Box'

export type TabPanelProps = {
  children?: React.ReactNode
  /**
   * The index of the tab
   */
  index: any
  /**
   * The value of the corresponding tab
   */
  value: any
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   * See the [`sx` page](https://mui.com/system/the-sx-prop/) for more details.
   */
  sx?: SxProps<Theme>
  unmountOnExit?: boolean
}

export function TabPanel(props: TabPanelProps) {
  const { children, index, value, sx = [], unmountOnExit = false } = props
  const [showChildren, setShowChildren] = useState<boolean>(false)

  useEffect(() => {
    if (index === value) setShowChildren(true)
  }, [index, value])

  return (
    <Box
      sx={[
        {
          width: '100%',
          margin: 0,
          padding: 0,
          display: index === value ? 'block' : 'none',
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {unmountOnExit ? (index === value ? children : null) : showChildren && children}
    </Box>
  )
}

export default TabPanel
